module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/582b9f12ce60392a8ef736c5dfabb4ce.svg";